/* esm.sh - @internetarchive/ia-item-user-lists@1.5.1 */
import{__decorate as n}from"/tslib?target=es2022";import{html as l,css as R,LitElement as q,nothing as F}from"/lit@^2.8.0?target=es2022";import{property as M,customElement as j,state as v,query as G}from"/lit@^2.8.0/decorators?target=es2022";import{Task as N,TaskStatus as $,initialState as _}from"/@lit/task@^1.0.0?target=es2022";import{UserListsService as D}from"/@internetarchive/ia-userlist-settings@^1.1.2?target=es2022";import{SearchService as B}from"/@internetarchive/search-service@^2.7.1?target=es2022";import{UserService as T}from"/@internetarchive/user-service@^0.1.3?target=es2022";var u=class{async fetchApiResponse(t,e){let i={};return e?.includeCredentials&&(i.credentials="include"),e?.method&&(i.method=e.method),e?.body&&(i.body=e.body),e?.headers&&(i.headers=e.headers),await(await fetch(t,i)).json()}};var C="https://archive.org";var L={create(o){let{serviceUrl:t,serviceProtocol:e="https://"}=o,i=t?`${e}${t}`:C;return new D({fetchHandler:new u,searchService:B.default,userService:new T,baseUrl:i})}};import"/@internetarchive/ia-dropdown@^2.2.0?target=es2022";import{__decorate as p}from"/tslib?target=es2022";import{html as a,css as O,LitElement as H,nothing as z}from"/lit@^2.8.0?target=es2022";import{property as x,customElement as P}from"/lit@^2.8.0/decorators?target=es2022";import{html as E}from"/lit@^2.8.0?target=es2022";import{ModalConfig as k}from"/@internetarchive/modal-manager@^2.0.0?target=es2022";import"/@internetarchive/ia-userlist-settings@^1.1.2?target=es2022";async function S(o,t,e){let i=document.querySelector("modal-manager");if(!i){let s=document.querySelector("body");i=document.createElement("modal-manager"),s?.appendChild(i)}let c=()=>{let s=i??document.querySelector("modal-manager");s?.showModal({config:new k,customModalContent:void 0,userClosedModalCallback:void 0}),s?.closeModal(),i?.removeAttribute("id")};i?.setAttribute("id","create-user-list-modal"),i.showModal({config:new k({title:E`List settings`,headerColor:"#194880",showCloseButton:!0,showHeaderLogo:!1,closeOnBackdropClick:!0}),userClosedModalCallback:()=>c(),customModalContent:E`
      <iaux-userlist-settings
        .userList=${{id:void 0,list_name:"",description:"",is_private:!1}}
        .userListsService=${o}
        @listModalClosed=${()=>c()}
        @userListError=${s=>{var b,f,w,g;let I=(g=(f=(b=s.detail.error)===null||b===void 0?void 0:b.reason)!==null&&f!==void 0?f:(w=s.detail.error)===null||w===void 0?void 0:w.message)!==null&&g!==void 0?g:"Unknown error from iaux-userlist-settings";console?.error("userListSettingsError",I)}}
        @userListSaving=${async()=>{t?.()}}
        @userListSaved=${async s=>{await e?.(s.detail.id),c()}}
      ></iaux-userlist-settings>
    `})}import{svg as U}from"/lit@^2.8.0?target=es2022";var h=U`<svg
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      >
    <g fill="currentColor" fill-rule="nonzero">
      <path d="m49.9459358 0c13.7978412 0 25.5896453 4.88776371 35.3754122 14.6632911 9.7857669 9.7755275 14.678652 21.554993 14.678652 35.3383967 0 13.7800281-4.8928851 25.5594936-14.678652 35.3350211-9.7857669 9.7755274-21.577571 14.6632911-35.3754122 14.6632911s-25.5716235-4.8877637-35.3213471-14.6632911c-9.74972353-9.7755275-14.6245887-21.554993-14.6245887-35.3383967-.00224931-9.0014064 2.23243779-17.3524613 6.70406469-25.0531645 4.47162691-7.7007033 10.54380341-13.7834037 18.21652941-18.24810129 7.6727261-4.46469761 16.0145067-6.69704641 25.0253417-6.69704641zm0 6c-7.9548389 0-15.2549008 1.95357387-22.0076943 5.8829701-6.7720278 3.9405885-12.0963254 9.2741139-16.0455165 16.0751171-3.93842488 6.7824623-5.89471047 14.0931257-5.89272481 22.040225 0 12.1941053 4.24437231 22.4500702 12.87283241 31.1013666 8.6242501 8.6470752 18.8695883 12.9003212 31.0731032 12.9003212 12.2065273 0 22.4734846-4.2557068 31.1349929-12.9081521 8.6603017-8.6512398 12.9190715-18.9040965 12.9190715-31.0935357l-.0036695-.6147591c-.1419586-11.9183989-4.4018851-21.9707923-12.915402-30.475401-8.6615083-8.6524453-18.9284656-12.9081521-31.1349929-12.9081521z" />
      <path d="m56 23v22h22v11h-22v22h-11l-.001-22h-21.999v-11h21.999l.001-22z" />
    </g>
  </svg>`;import{svg as A}from"/lit@^2.8.0?target=es2022";var m=A`<svg viewBox="0 0 100 100"
xmlns="http://www.w3.org/2000/svg"
>
<path
  d="m33.3333333 90-33.3333333-33.3333333 13.3333333-13.3333334 20 20 53.3333334-53.3333333 13.3333333 13.3333333z"
  fill-rule="evenodd" fill="currentColor"
/>
</svg>`;var d=class extends H{constructor(){super(...arguments),this.itemId="",this.lists=[],this.closeDropdown=()=>{this.dispatchEvent(new CustomEvent("closeDropdown",{bubbles:!0,composed:!0}))},this.selectDropdown=()=>{this.dispatchEvent(new CustomEvent("selectDropdown",{bubbles:!0,composed:!0}))},this.updateDropdown=()=>{this.dispatchEvent(new CustomEvent("updateDropdown",{bubbles:!0,composed:!0}))},this.optionClicked=(t,e)=>{var i;t.stopPropagation(),(i=e.selectedHandler)===null||i===void 0||i.call(e,e)},this.onSelected=async t=>{this.selectDropdown();let e=this.lists.find(i=>t.id===i.id)||{};e.item_is_member?await this.removeMember(e.id,e.member_id):await this.addMember(e.id),this.updateDropdown()},this.addCreatedList=async t=>{await this.addMember(t),this.dispatchEvent(new CustomEvent("listCreated",{detail:{totalLists:this.lists.length}})),this.updateDropdown()},this.createList=()=>{this.closeDropdown(),S(this.userListsService,this.selectDropdown,this.addCreatedList)},this.userListOptions=()=>{let t=[];return t=this.lists.map(e=>this.listOption(e)),t.push(this.newListOption),t}}listOption(t){return{id:t.id,label:this.labelTemplate(t),isSelected:t.item_is_member,selectedHandler:e=>this.onSelected(e)}}get newListOption(){return{id:"create-new-list",label:a` <ia-icon-label>
        <div slot="icon" class="icon-size">${h}</div>
        Create new list
      </ia-icon-label>`,selectedHandler:()=>this.createList()}}async addMember(t){var e;await((e=this.userListsService)===null||e===void 0?void 0:e.addMemberToList(t,{identifier:this.itemId})),this.dispatchEvent(new CustomEvent("addMember",{detail:{listId:t,itemId:this.itemId}}))}async removeMember(t,e){var i;await((i=this.userListsService)===null||i===void 0?void 0:i.removeMemberFromList(t,e)),this.dispatchEvent(new CustomEvent("removeMember",{detail:{listId:t,itemId:this.itemId}}))}labelTemplate(t){let{item_is_member:e,list_name:i}=t;return a`
      <ia-icon-label>
        <div slot="icon" class="icon-size">
          ${e?m:z}
        </div>
        <div class="truncate">${i}</div>
      </ia-icon-label>
    `}optionTemplate(t){return a` <li class="${t.isSelected?"selected":""}">
      ${this.buttonTemplate(t)}
    </li>`}buttonTemplate(t){return a`
      <button @click=${e=>this.optionClicked(e,t)}>
        ${t.label}
      </button>
    `}render(){return a` ${this.userListOptions().map(t=>this.optionTemplate(t))} `}static get styles(){return O`
      :host {
        display: inline;
        background-color: #fff;
      }

      li:hover {
        list-style: none;
        cursor: pointer;
      }

      li {
        background: #fff;
        list-style: none;
        height: 30px;
        cursor: pointer;
        border-bottom: 1px #f1f1f1 solid;
        color: #2c2c2c;
        width: 140px;
        text-overflow: ellipsis;
      }

      li button {
        background: none;
        color: inherit;
        border: none;
        font: inherit;
        cursor: pointer;
        width: 100%;
        padding: 0px 10px;
        font-size: 12px;
        --iconLabelGutterWidth: 8px;
        --iconWidth: 12px;
        margin: 0;
      }

      /* cover the list with the label */
      li > * > :first-child {
        margin: 0;
        display: inline-block;
        height: 30px;
        box-sizing: border-box;
        text-align: left;
        line-height: initial;
      }

      /* color opacity calculator: https://codepen.io/quyenvsp/pen/jOLBBmX
        foreground: #2c2c2c 44;
        background: #fff;
      */
      button:hover {
        /* 10% 234 */
        background-color: #eaeaea;
      }

      button:focus,
      button:focus-visible {
        /* 20% 213 */
        background-color: #d5d5d5;
      }

      button:active {
        /* 30% 192 */
        background-color: #c0c0c0;
      }

      .icon-size {
        width: 12px;
        height: 12px;
      }
    `}};p([x({type:String})],d.prototype,"itemId",void 0);p([x({type:Array})],d.prototype,"lists",void 0);p([x({type:Object})],d.prototype,"userListsService",void 0);d=p([P("item-user-lists")],d);import{html as W}from"/lit@^2.8.0?target=es2022";var y=W`<img
  src="https://archive.org/images/loading.gif"
  alt="Loading..."
/>`;var r=class extends q{constructor(){super(...arguments),this.baseHost="archive.org",this.item="",this.selectedCount=0,this.userListData=[],this.dataAction="initial",this.userListsService=L.create({serviceUrl:this.baseHost}),this.listID="",this.closeListener=()=>{this.dropdown.open=!1},this.selectListener=()=>{this.dropdown.open=!1,this.dataActionTask.run(["initial"])},this.updateListener=()=>{this.dataActionTask.run(["load"])},this.dataActionTask=new N(this,{task:async([t])=>!this.item||!this.userListsService?_:t==="load"?this.updateSelectedCount():_,args:()=>[this.dataAction],autoRun:!1})}async dropdownClicked(t){t.preventDefault(),this.dropdown.open?this.dropdown.open=!1:(await this.dataActionTask.run(["load"]),this.dropdown.open=!0)}async firstUpdated(){var t;await new Promise(e=>setTimeout(e,0)),this.addEventListener("closeDropdown",this.closeListener),this.addEventListener("selectDropdown",this.selectListener),this.addEventListener("updateDropdown",this.updateListener),(t=this.dataActionTask.run(["load"]))===null||t===void 0||t.then(()=>{this.dispatchEvent(new CustomEvent("userItemListDataReceived",{detail:{total_lists:this.userListData.length}}))})}updated(t){t.has("baseHost")&&this.baseHost&&t.get("baseHost")&&this.reloadService()}reloadService(){this.userListsService=L.create({serviceUrl:this.baseHost}),this.dataActionTask.run(["load"])}async updateItemUserList(){var t;let e=await this.userListsService.fetchOwnListsContainingItem(this.item);if(!e.success)throw new Error((t=e.error)===null||t===void 0?void 0:t.message);return this.userListData=e.success,this.userListData}async updateSelectedCount(){let t=await this.updateItemUserList();return this.selectedCount=t.filter(e=>e.item_is_member).length,this.selectedCount}renderIcon(t){return l`
      <div slot="icon" class="icon-img">${t}</div>
      <div class="label">
        <div class="def">Add to list</div>
        <div class="sm">Lists</div>
      </div>
    `}renderError(){return l`
      <div class="label">User Lists<br />Load Error</div>
      <div class="label-sm">Load<br />Error</div>
    `}mainButton(t){return l`
      <div class="action-bar-text">
        <ia-icon-label>
          ${t?this.renderIcon(t):this.renderError()}
        </ia-icon-label>
      </div>
    `}get isFetched(){return this.dataActionTask.status===$.COMPLETE}get isDisabled(){return this.dataActionTask.status!==$.COMPLETE}get itemUserListsTemplate(){return l`
      <item-user-lists
        slot="list"
        .itemId=${this.item}
        .lists=${this.userListData}
        .userListsService=${this.userListsService}
        @addMember=${t=>this.dispatchEvent(new CustomEvent("memberAdded",{detail:{...t.detail,total_items:this.selectedCount}}))}
        @removeMember=${t=>this.dispatchEvent(new CustomEvent("memberRemoved",{detail:{...t.detail,total_items:this.selectedCount}}))}
        @userListError=${t=>{this.dispatchEvent(new CustomEvent("userListError",{detail:{...t.detail}}))}}
        @listCreated=${t=>{this.dispatchEvent(new CustomEvent("listCreated",{detail:{...t.detail,total_lists:this.selectedCount}}))}}
      >
      </item-user-lists>
    `}render(){return l`
      <div class="list-container">
        <ia-dropdown
          class="list-dropdown"
          ?isDisabled=${this.isDisabled}
          ?openViaCaret=${!1}
          ?isCustomList=${!0}
          ?closeOnEscape=${!0}
          ?closeOnBackdropClick=${!0}
          ?hasCustomClickHandler=${!0}
          @click=${this.isDisabled?F:this.dropdownClicked}
        >
          <div class="list-title" slot="dropdown-label">
            ${this.dataActionTask.render({initial:()=>this.mainButton(y),pending:()=>this.mainButton(y),complete:t=>this.mainButton(t===0?h:m),error:()=>this.mainButton(void 0)})}
          </div>
          ${this.itemUserListsTemplate}
        </ia-dropdown>
      </div>
    `}};r.styles=R`
    :host {
      display: block;
    }

    ia-icon-label {
      cursor: pointer;
      display: flex;
    }

    .icon-img {
      height: 16px;
      width: 16px;
      padding-bottom: 2px;
    }

    div.list-title {
      font-weight: 600;
      color: #2c2c2c;
    }

    ia-dropdown {
      --dropdownBgColor: #fff;
      --dropdownItemPaddingRight: 0;
      --dropdownItemPaddingLeft: 2px;
      --dropdownBorderColor: #2c2c2c;
      --dropdownBorderWidth: 2px;
      --iconLabelGutterWidth: 4px;
      --iconWidth: 10px;
      --dropdownOffsetTop: 2px;
      --buttonSlotPaddingRight: 0;
      --dropdownMainButtonFlexDirection: column;
      --dropdownMainButtonPadding: 6px 4px;
      --dropdownMainButtonHoverBgColor: rgba(44, 44, 44, 0.1);
      --dropdownMainButtonActiveBgColor: rgba(44, 44, 44, 0.3);
      --iconLabelGutterWidth: 0;
      --iconWidth: 16px;
      --dropdownMainButtonBorder: 2px solid #2c2c2c;
      --dropdownMainButtonBorderRadius: 3px;
    }

    .action-bar-text {
      font-size: 14px;
      font-weight: normal;
      -webkit-user-select: none;
      user-select: none;
      --iconLabelFlexDirection: column;
      --iconLabelGutterWidth: 0;
      --iconWidth: 16px;
      font-family: inherit;
    }

    .action-bar-text .label {
      display: flex;
      align-items: center;
    }

    /* inside button.click-main, classname from details.inc buttons */
    @media (min-width: 992px) {
      .action-bar-text .label {
        height: 20px;
      }
      .action-bar-text .label .sm {
        display: none;
      }
    }

    /* List button */
    @media (max-width: 991px) {
      .action-bar-text .label {
        height: 15px;
      }
      .action-bar-text .label .def {
        display: none;
      }
      .action-bar-text .label .sm {
        font-size: 13px;
      }
    }

    .click-backdrop {
      position: fixed;
      top: 0px;
      left: 0px;
      width: 100vw;
      height: 100vh;
      z-index: 1;
      background-color: transparent;
    }
  `;n([M({type:String})],r.prototype,"baseHost",void 0);n([M({type:String})],r.prototype,"item",void 0);n([v()],r.prototype,"selectedCount",void 0);n([v({hasChanged(o,t){if(o?.length!==t?.length)return!0;for(let e=0;e<o.length;e+=1)if(o[e].item_is_member!==t[e].item_is_member)return!0;return!1}})],r.prototype,"userListData",void 0);n([v()],r.prototype,"dataAction",void 0);n([v()],r.prototype,"userListsService",void 0);n([G("ia-dropdown")],r.prototype,"dropdown",void 0);r=n([j("ia-item-user-lists")],r);export{r as IaItemUserLists};
//# sourceMappingURL=ia-item-user-lists.mjs.map